import { render } from "./BaseFieldslListItem.vue?vue&type=template&id=04e6037e&scoped=true&ts=true"
import script from "./BaseFieldslListItem.vue?vue&type=script&lang=ts"
export * from "./BaseFieldslListItem.vue?vue&type=script&lang=ts"

import "./BaseFieldslListItem.vue?vue&type=style&index=0&id=04e6037e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e6037e"]])

export default __exports__